import { Result, Button } from 'antd';

interface Props {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title = 'Ocurrió un Error', message, onRetry }: Props) {
  return (
    <Result
      status="error"
      title={title}
      subTitle={message}
      extra={onRetry ? <Button type="primary" onClick={onRetry}>Reintentar</Button> : undefined}
    />
  );
}
